import { Dispatch, SetStateAction } from "react";
import { FormattedMessage } from "react-intl";

import { ReactComponent as CircleCross } from "assets/images/icons/CircleCross.svg";
import testIds from "constants/testIds";
import ActionButton from "components/molecules/TopNav/common/TopNavV2/TopNavActions/ShipperProviderActions/ActionButton";

interface UnsubscribeMenuItemProps {
  setIsOpenUnsubscribeDialog: Dispatch<SetStateAction<boolean>>;
}

export default function UnsubscribeMenuItem({ setIsOpenUnsubscribeDialog }: UnsubscribeMenuItemProps) {
  return (
    <ActionButton
      onClick={() => {
        setIsOpenUnsubscribeDialog(true);
      }}
      icon={<CircleCross stroke="black" style={{ transform: "scale(1.35)" }} />}
      title={<FormattedMessage id="components.molecules.navigation.unsubscribe" defaultMessage="Unsubscribe" />}
      testId={testIds.SHIPMENT_DASHBOARD_UNSUBSCRIBE}
    />
  );
}
